import { createApiClient, ApiClient, IHandlers } from '../services/ApiClient';
import { notify, Session, confirm } from '../components/Utils';
import { RootState } from '../store';
import { findIndex, remove, isEmpty, isObject } from 'lodash';
import * as types from './ActionTypes';
import { history } from '../router';
import {
  FETCH_VOTES_RESULT,
  MARK_ALL_VISITED,
  MARK_VISITED,
  SET_ERROR,
} from './ActionTypes';
import { PAGINATION, URL_PREFIX } from '../const/forms';
import { INITIAL_RULES } from '../const/initial_rules';

import { ICreateForm } from './types';
import { FormState } from '../reducers';

let api = createApiClient();

export function requestUnchekUpdate(formId: any, valuesId: any) {
  return {
    type: types.REQUEST_UNCHEK_UPDATE,
    payload: {
      formId,
      valuesId,
    },
  };
}

export function createSession(uid: string, obj: object) {
  return (dispath: any) => {
    api.createSession(uid, obj, {
      success: (response) => {
        Session.setSession(response.id);

        dispath({ type: types.CREATE_REQUEST_BEFORE, payload: null });
        dispath(fetchForm(uid, response.id));
        dispath(setFormUid(uid));
        dispath({ type: types.SET_STATUS_DEFAULT, payload: 0 });
      },
    });
  };
}

export function checkedPanel(
  panelId: string,
  checked: boolean,
  error: any | undefined,
) {
  return (dispath: any) => {
    dispath(setError(panelId, error));
    dispath(addValue(panelId, checked ? '1' : null, false));
    dispath({
      type: types.CHECKED_PANEL,
      payload: {
        panelId,
        checked,
      },
    });
  };
}

export function getForms(page: number, pagesize: number) {
  return (dispatch: any) => {
    dispatch({ type: types.LOADING_START, payload: 'forms' });
    api.getForms(page, pagesize, {
      success: (response) => {
        dispatch({ type: types.FETCH_FORMS, payload: response });
      },
      error: (error) => {
        if (error && error.status === 401) {
          if (window.top !== window.self) {
            // @ts-ignore
            window.top.location.href = '/#/not-authorized';
          } else {
            window.location.href = '/#/not-authorized';
          }
        }
      },
      anyway: () => {
        dispatch({ type: types.LOADING_FINISH, payload: 'forms' });
      },
    });
  };
}

export function getVotesResult(formId: string) {
  return (dispatch: any) => {
    api.getVotesResult(formId, {
      success: (response) => {
        dispatch({ type: types.FETCH_VOTES_RESULT, payload: response });
      },
    });
  };
}

function initRules(dispatch: any, fields, values) {
  if (fields.length > 0) {
    let i = fields.length;

    while (i--) {
      if (typeof fields[i].extra.init !== 'undefined') {
        if (typeof INITIAL_RULES[fields[i].extra.init] !== 'undefined') {
          INITIAL_RULES[fields[i].extra.init].callback(dispatch, values);
        }
      }
    }
  }
}

export function loadFrom(form_type: string, process_id: number) {
  return (dispatch: any) => {
    dispatch({ type: types.LOADING_START, payload: 'form' });
    api.openForm(form_type, process_id, {
      success: (response) => {
        // Session.setSession(parseInt(valuesId));

        dispatch({ type: types.CREATE_REQUEST_BEFORE, payload: null });
        dispatch({
          type: types.OPEN_FORM,
          payload: { ...response, form_type, process_id },
        });

        const fields = [];
        const sections = response.form.sections.map((currentValue) => {
          typeof currentValue !== 'undefined' &&
            currentValue.controls.map((value) => fields.push(value));
        });
        if (response.form.sections.length > 0) {
          const sectionToOpen =
            response.form.sections.find((sect) => !sect.hidden) ||
            response.form.sections[0];

          dispatch({
            type: types.SET_SECTION,
            payload: {
              id: sectionToOpen.id,
            },
          });
        }
        const autoCompleteFields = fields.filter(
          (field) => field.extra && field.extra.init,
        );

        initRules(dispatch, autoCompleteFields, response.values);
      },
      error: (error) => {
        if (error && error.status === 401) {
          if (window.top !== window.self) {
            // @ts-ignore
            window.top.location.href = '/#/not-authorized';
          } else {
            window.location.href = '/#/not-authorized';
          }
        }
      },
      anyway: () => {
        dispatch({ type: types.LOADING_FINISH, payload: 'form' });
      },
    });
  };
}

export function fetchValues() {
  return (dispath: any) => {
    dispath(clearValues());
    dispath({ type: types.FETCH_FORM, payload: null });

    api.getAllValues({
      success: (response) => {
        dispath({ type: types.FETCH_VALUES, payload: response });
      },
    });
  };
}

export function redirectInLK(url: string) {
  return (dispath: any) => {
    const api = createApiClient();
    api.redirect(url);
  };
}

export function setFormUid(uid: string) {
  return {
    type: types.SET_FORM_UID,
    payload: uid,
  };
}

export function createForm(values: ICreateForm) {
  return (dispatch: any) => {
    dispatch({ type: types.LOADING_START, payload: 'companies' });
    api.createForm(
      { ...values },
      {
        success: (response) => {
          dispatch({ type: types.LOADING_FINISH, payload: 'companies' });
          const { process_id, form_type } = response;
          history.push(`${URL_PREFIX}/forms/${form_type}/${process_id}`);
          dispatch(getForms(PAGINATION.page, PAGINATION.pagesize));
        },
        error: (error) => {
          console.log('ACTION: createForm API error', error);
          dispatch({ type: types.LOADING_FINISH, payload: 'companies' });
        },
      },
    );
  };
}

/**
 * Alternative create form action like createForm
 * @param protocol
 * @param enFieldsAvailable
 */
export function onUploadProtocol({ protocol, enFieldsAvailable }) {
  return (dispatch: any, getState: () => RootState) => {
    dispatch({ type: types.LOADING_START, payload: 'companies' });

    api.onUploadProtocols(
      {
        protocol,
        enFieldsAvailable,
        // if tried creating once, create w/ force
        forceWithoutDocs: getState().forms.isCreateWithoutDocsReady,
      },
      {
        success: (response) => {
          // reset error & loading state
          dispatch({
            type: types.SET_CREATE_FORM_WITHOUT_DOCS_READY,
            payload: false,
          });
          dispatch({
            type: types.ERROR_CREATE_FORM,
            payload: undefined,
          });
          dispatch({ type: types.LOADING_FINISH, payload: 'companies' });

          // redirect
          const { process_id, form_type } = response.data;
          history.push(`${URL_PREFIX}/forms/${form_type}/${process_id}`);
          dispatch(getForms(PAGINATION.page, PAGINATION.pagesize));
        },
        error: (error) => {
          console.log('ACTION: onUploadProtocol API error', error);

          // status for force retry
          if (error.response.status === 400) {
            dispatch({
              type: types.ERROR_CREATE_FORM,
              payload:
                'Не определена заявка, соответствующая приложенному протоколу. При нажатии на кнопку "Создать заявку" будет создана пустая заявка.',
            });
            dispatch({
              type: types.SET_CREATE_FORM_WITHOUT_DOCS_READY,
              payload: true,
            });
          }
          // real error status
          if (error.response.status !== 400) {
            dispatch({
              type: types.ERROR_CREATE_FORM,
              payload: error.response.data.detail,
            });
          }

          dispatch({ type: types.LOADING_FINISH, payload: 'companies' });
        },
      },
    );
  };
}

/**
 * reset errors & CREATE_FORM_WITHOUT_DOC state on protocol file change
 */
export function onChangeProtocol() {
  return (dispatch: any) => {
    dispatch({
      type: types.SET_CREATE_FORM_WITHOUT_DOCS_READY,
      payload: false,
    });
    dispatch({
      type: types.ERROR_CREATE_FORM,
      payload: undefined,
    });
  };
}

export function errorCreateForm(message: string) {
  return (dispatch: any) => {
    dispatch({
      type: types.ERROR_CREATE_FORM,
      payload: message,
    });
  };
}

export function copyForm(form_type: string, process_id: number) {
  return (dispatch: any) => {
    confirm('Копировать заявку?', () => {
      api.copyForm(form_type, process_id, {
        success: (response) => {
          const { process_id, form_type } = response;
          history.push(`${URL_PREFIX}/forms/${form_type}/${process_id}`);
          dispatch(getForms(PAGINATION.page, PAGINATION.pagesize));
        },
        error: (error, response) => {
          notify('Не удалось скопировать заявку');
        },
      });
    });
  };
}

export function deleteForm(
  form_type: string,
  process_id: number,
  current_page: number,
) {
  return (dispatch: any) => {
    confirm('Удалить заявку?', () => {
      api.deleteForm(form_type, process_id, {
        success: () => {
          dispatch(getForms(current_page, PAGINATION.pagesize));
        },
        error: (error, response) => {
          notify(
            'Не удалось удалить заявку. Возможно документы уже отправлены',
          );
        },
      });
    });
  };
}

export function revokeForm(
  form_type: string,
  process_id: number,
  message: string,
) {
  return (dispatch: any) => {
    api.revokeForm(form_type, process_id, message, {
      success: () => {
        dispatch(getForms(PAGINATION.page, PAGINATION.pagesize));
      },
      error: (error, response) => {
        notify('Не удалось отозвать документы');
      },
    });
  };
}

export function fetchForm(uid: string, values: number) {
  return (dispatch: any) => {
    dispatch({ type: types.LOADING_START, payload: 'forms' });
    dispatch(clearValues());
    dispatch({ type: types.FETCH_FORM, payload: null });

    let checkPanels = [];
    api.getFormByUid(uid, values, {
      success: (response) => {
        dispatch({
          type: types.FETCH_FORM,
          payload: { ...response, status: 0 },
        });
        dispatch(setSection(response.sections[0].id));

        history.push(`/create/${uid}/${Session.getSession()}`);
      },
      anyway: () => {
        dispatch({ type: types.LOADING_FINISH, payload: 'forms' });
      },
    });
  };
}

export function clearHistory() {
  return (dispatch: any) => {
    dispatch({ type: types.SET_HISTORY, payload: [] });
  };
}

export function getHistory(id: string) {
  return (dispatch: any) => {
    dispatch({ type: types.LOADING_START, payload: 'request-history' });
    api.getHistory(Number(id), {
      success: (response) => {
        dispatch({
          type: types.SET_HISTORY,
          payload: response.sort(
            (a, b) =>
              new Date(b.create_at).getTime() - new Date(a.create_at).getTime(),
          ),
        });
        dispatch({ type: types.LOADING_FINISH, payload: 'request-history' });
      },
      error: (error) => {
        console.log('ERROR', error);
        dispatch({ type: types.LOADING_FINISH, payload: 'request-history' });
        if (error && error.status === 401) {
          if (window.top !== window.self) {
            // @ts-ignore
            window.top.location.href = '/#/not-authorized';
          } else {
            window.location.href = '/#/not-authorized';
          }
        }
      },
    });
  };
}

export function addFile(controlid: string, value: any) {
  return (dispath: any, getState: () => RootState) => {
    const state = getState().forms;
    const result = {
      type: types.ADD_VALUE,
      payload: [...state.values],
    };

    let idx = findIndex(state.values, (o: any) => o.controlid === controlid);

    if (idx > -1 && isEmpty(value)) {
      //delete
      result.payload = remove(
        state.values,
        (o: any) => o.controlid !== controlid,
      );
    } else if (idx === -1 && isEmpty(value) === false) {
      //create
      result.payload = [...state.values, { controlid, value }];
    } else if (idx > -1 && isEmpty(value) === false) {
      //update
      result.payload = [...state.values];
      result.payload[idx].value = value;
    }
    dispath(result);
  };
}

function getControlsByType(form: any, type: string) {
  const result = [];
  for (let section of form.sections) {
    const control = section.controls.find((t) => t.type === type);
    if (control) {
      result.push(control);
    }
  }
  return result;
}

function checkRecal(schema: any, controlid: string): boolean {
  const controls: any = getControlsByType(schema, 'TotalHeader');
  if (controls.length > 0) {
    const totalHeader = controls[0];
    for (let el of totalHeader.elements) {
      if (controlid.indexOf(el as string) === 0) {
        return true;
      }
    }
  }
  return false;
}

function recaleSumGrant(
  schema: any,
  values: any,
  dispath: any,
  api: ApiClient,
) {
  // const controls: any = getControlsByType(schema, 'TotalHeader');
  // const countYear = values.find(t => t.controlid === 'CountYear');
  // if (controls.length > 0){
  //     let total: number = null;
  //     const totalHeader = controls[0];
  //     const lockControl = values.find(t => t.controlid === 'Lock');
  //     for(let control of values) {
  //         for(let el of totalHeader.elements){
  //           if(control.controlid.indexOf(el as string) === 0){
  //             total += parseFloat(control.value);
  //           }
  //         }
  //     }
  //     if(total && (!lockControl || lockControl.value === '0')){
  //         const newState = [...values];
  //         const sumGrantIndex =  values.findIndex(o => o.controlid === 'SumGrant');
  //         const value = countYear.value < 1 ? total.toFixed(2): ((total / 100) * 75).toFixed(2)
  //         if(sumGrantIndex > -1) {
  //             newState[sumGrantIndex].value = value;
  //         } else {
  //             newState.push({ controlid: 'SumGrant', value });
  //         }
  //         dispath({
  //             type: types.ADD_VALUE,
  //             payload: [...newState]
  //         });
  //         api.setValueSync('SumGrant', value);
  //         setError('SumGrant', undefined)(dispath);
  //     }
  // }
}

function recalSumGrantDynamicGrid(
  schema: any,
  values: any,
  dispath: any,
  api: ApiClient,
) {
  // const controls: any = getControlsByType(schema, 'DynamicGridPanel');
  // const countYear = values.find(t => t.controlid === 'CountYear');
  // const sumGrantIndex =  values.findIndex(o => o.controlid === 'SumGrant');
  // if(controls.length > 0){
  //     const newState = [...values];
  //     const lockControl = values.find(t => t.controlid === 'Lock');
  //     const stateControl = values.find(t => t.controlid === controls[0].id);
  //     if(stateControl){
  //         const valueTotal: number = stateControl.value.filter(t => t.total).reduce((s,v) => s + parseFloat(v.total),0);
  //         const value = countYear.value < 1 ? valueTotal.toFixed(2): ((valueTotal / 100) * 75).toFixed(2);
  //         if(!lockControl || lockControl.value === '0'){
  //             if(sumGrantIndex > -1) {
  //                 newState[sumGrantIndex].value = value;
  //             } else {
  //                 newState.push({ controlid: 'SumGrant', value });
  //             }
  //             dispath({
  //                 type: types.ADD_VALUE,
  //                 payload: [...newState]
  //             });
  //             api.setValueSync('SumGrant', value);
  //             setError('SumGrant', undefined)(dispath);
  //         }
  //     }
  // }
}

export function recal() {
  return (dispath: any, getState: () => RootState) => {
    const state = getState().forms;
    const api = createApiClient(state.form_type, state.process_id);

    recaleSumGrant(state.form, state.values, dispath, api);
    recalSumGrantDynamicGrid(state.form, state.values, dispath, api);
  };
}

interface AddValueSuccessHandlerProps {
  result: any;
  state: FormState;
  refresh: boolean;
}

export function addValue(controlid: string, value: any, refresh: boolean) {
  return (dispatch: any, getState: () => RootState) => {
    const onSuccess = ({
      result,
      state,
      refresh,
    }: {
      result: any;
      state: FormState;
      refresh: boolean;
    }) => {
      dispatch(result);

      if (refresh)
        dispatch({
          type: types.ATTEMPT_TO_SEND,
          payload: state.countToSend + 1,
        });
    };

    handleAddValue({
      getState,
      dispatch,
      controlid,
      value,
      onCreateSuccess: onSuccess,
      onDeleteSuccess: onSuccess,
      onUpdateSuccess: onSuccess,
      refresh,
    });
  };
}

export function addMultipleValues(
  controlsData: {
    controlid: string;
    value: any;
    refresh: boolean;
    action?: any;
  }[],
) {
  return (dispatch: any, getState: () => RootState) => {
    const onSuccess = ({
      result,
      state,
      refresh,
    }: AddValueSuccessHandlerProps) => {
      dispatch(result);

      if (refresh)
        dispatch({
          type: types.ATTEMPT_TO_SEND,
          payload: state.countToSend + 1,
        });
    };

    const addPromises: Promise<AddValueSuccessHandlerProps>[] = [];

    controlsData.forEach(({ controlid, value, refresh }) => {
      const promise = new Promise<AddValueSuccessHandlerProps>(
        (resolve, reject) => {
          const successHandler = (props: AddValueSuccessHandlerProps) => {
            resolve(props);
          };

          handleAddValue({
            getState,
            dispatch,
            controlid,
            value,
            onCreateSuccess: successHandler,
            onDeleteSuccess: successHandler,
            onUpdateSuccess: successHandler,
            refresh,
          });
        },
      );

      addPromises.push(promise);
    });

    Promise.all(addPromises).then((res) => {
      res.forEach((controlData) => {
        onSuccess(controlData);
      });
    });
  };
}

function handleAddValue({
  value,
  controlid,
  getState,
  dispatch,
  onDeleteSuccess,
  onCreateSuccess,
  onUpdateSuccess,
  refresh,
}: {
  value: any;
  controlid: string;
  onDeleteSuccess: (props: AddValueSuccessHandlerProps) => void;
  onCreateSuccess: (props: AddValueSuccessHandlerProps) => void;
  onUpdateSuccess: (props: AddValueSuccessHandlerProps) => void;
  getState: () => RootState;
  dispatch: any;
  refresh: boolean;
}) {
  const state = getState().forms;
  const newValue = value;

  const api = createApiClient(state.form_type, state.process_id);

  let idx = findIndex(state.values, (o: any) => o.controlid === controlid);

  const result = {
    type: types.ADD_VALUE,
    payload: [...state.values],
  };

  if (idx > -1 && isEmpty(value)) {
    //delete
    result.payload = remove(
      state.values,
      (o: any) => o.controlid !== controlid,
    );
    dispatch(result);
    api.removeValue(controlid, Date.now(), {
      success: () => {
        onDeleteSuccess({ result, state, refresh });
      },
    });
  } else if (idx === -1 && isEmpty(value) === false) {
    //create
    result.payload = [...state.values, { controlid, value }];

    dispatch(result);
    api.setValue(controlid, newValue, {
      success: () => {
        onCreateSuccess({ result, state, refresh });
      },
    });
  } else if (idx > -1 && isEmpty(value) === false) {
    //update
    if (
      isObject(newValue) ||
      (!isObject(newValue) && state.values[idx].value != newValue)
    ) {
      result.payload = [...state.values];
      if (result.payload[idx]) {
        result.payload[idx].value = value;
        dispatch(result);
      }
      api.setValue(controlid, newValue, {
        success: () => {
          onUpdateSuccess({ result, state, refresh });
        },
      });
    }
  }
}

export function setSection(id: string) {
  return {
    type: types.SET_SECTION,
    payload: {
      id,
    },
  };
}

export function clearValues() {
  return {
    type: types.CLEAR_VALUES,
    payload: {},
  };
}

export function incrimentToSend() {
  return (dispath: any, getState: () => RootState) => {
    const state = getState().forms;

    dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1 });
  };
}

export function onPlageSearch(handlers: IHandlers) {
  return (dispath: any, getState: () => RootState) => {
    const state = getState().forms;
    api?.getPlagsearch(state.form_type, state.process_id, handlers);
  };
}

export function getRecommendations(handlers: IHandlers) {
  return (dispath: any, getState: () => RootState) => {
    const state = getState().forms;
    api?.getRecommendations(state.form_type, state.process_id, handlers);
  };
}

export function removeReportPdf(formId: string, values: string) {
  return (dispath: any, getState: () => RootState) => {
    const api = createApiClient();
    api.removeReportPdf(formId, values, {
      success: () => {
        dispath(fetchValues());
      },
    });
  };
}

export function copyValue(sourceId: string, targetId: string) {
  return (dispath: any, getState: () => RootState) => {
    const { values, formUid } = getState().forms;
    const valueIdx = findIndex(
      values,
      (val: any) => val.controlid === sourceId,
    );
    const api = createApiClient(formUid);

    if (valueIdx > -1) {
      const value = values[valueIdx].value;
      if (isObject(value)) {
        api.setValueSync(targetId, value, {
          success: () => {
            dispath({
              type: types.ADD_VALUE,
              payload: [...values, { controlid: targetId, value }],
            });
          },
        });
      }
    }
  };
}

export function getTags() {
  return (dispatch: any, getState: () => RootState) => {
    const api = createApiClient();
    api.getTags({
      success: (response) => {
        dispatch({
          type: types.SET_TAGS,
          payload: response.sort((t1, t2) => {
            if (t1.name.ru < t2.name.ru) {
              return -1;
            }
            if (t1.name.ru > t2.name.ru) {
              return 1;
            }
            return 0;
          }),
        });
      },
    });
    api.getCities({
      success: (response) => {
        dispatch({
          type: types.SET_CITIES,
          payload: response.sort((t1, t2) => {
            if (t1.name.ru < t2.name.ru) {
              return -1;
            }
            if (t1.name.ru > t2.name.ru) {
              return 1;
            }
            return 0;
          }),
        });
      },
    });
  };
}

export function markVisited(id: string) {
  return (dispatch: any, getState: () => RootState) => {
    dispatch({
      type: MARK_VISITED,
      payload: id,
    });
  };
}

export function markAllVisited() {
  return (dispatch: any, getState: () => RootState) => {
    dispatch({
      type: MARK_ALL_VISITED,
    });
  };
}

export function setError(id: string, error: any) {
  return (dispatch) => {
    dispatch({
      type: SET_ERROR,
      payload: {
        id,
        error,
      },
    });
  };
}

/**
 * Получить данные о вопросах эксперта
 * @param form_type
 * @param process_id
 */
export function getExpertData(form_type, process_id) {
  return (dispatch: any) => {
    api.getExpertData(form_type, process_id, {
      success: (payload) => {
        dispatch({
          type: FETCH_VOTES_RESULT,
          payload,
        });
      },
      error: () => {},
    });
  };
}

/**
 * Сохранить текстовый ответ на вопрос эксперта
 * @param form_type
 * @param question_id
 * @param text
 */
export function saveTextAnswerExpertData(form_type, question_id, text) {
  return (dispatch: any) => {
    console.log('Сохранить текстовый ответ на вопрос эксперта');
    console.log(form_type, question_id, text);
    //TODO Меняем значение в объекте, затем делаем запрос, при успехе ничего не делаем, при ошибке откатываем значение "назад"
    api.saveTextAnswerExpertData(form_type, question_id, text, {
      success: (data) => {
        dispatch({
          type: 'SAVE_TEXT_ANSWER',
          payload: {
            id: question_id,
            text,
          },
        });
      },
      error: () => {},
    });
  };
}

/**
 * Загрузить файл к вопросу эксперта
 */
export function uploadFileExpertData(form_data, form_type, question_id) {
  return (dispatch: any) => {
    console.log('Загрузить файл к вопросу эксперта');
    console.log(form_data, form_type, question_id);

    api.uploadFileExpertData(form_data, form_type, question_id, {
      success: ({ data }) => {
        dispatch({
          type: 'UPLOAD_FILE_ANSWER',
          payload: {
            id: question_id,
            file: data,
          },
        });
      },
      error: () => {},
    });
    //TODO
  };
}

/**
 * Удалить файл из вопроса эксперта
 */
export function deleteFileExpertData(form_type, question_id, file_uuid) {
  return (dispatch: any) => {
    console.log('Удалить файл из вопроса эксперта');
    console.log(form_type, question_id, file_uuid);
    //TODO
    api.deleteFileExpertData(form_type, question_id, file_uuid, {
      success: () => {
        dispatch({
          type: 'DELETE_FILE_ANSWER',
          payload: {
            id: question_id,
            file_uuid,
          },
        });
      },
      error: () => {},
    });
  };
}

/**
 * Отправить ответ на вопрос эксперта
 */
export function sendExpertData(form_type, question_id) {
  return (dispatch: any) => {
    console.log('Отправить ответ на вопрос эксперта');
    console.log(form_type, question_id);

    api.sendExpertData(form_type, question_id, {
      success: () => {
        dispatch({
          type: 'SEND_ANSWER',
          payload: {
            id: question_id,
          },
        });
      },
      error: () => {},
    });
  };
}
